if (!customElements.get('sticky-atc')) {

class StickyATC extends HTMLElement {

  constructor() {

    super({
      name: 'Sticky ATC',
      version: '2.0.0'
    })

    this.quantityInputWrapper = this.querySelector('.atc_quantity');
    this.quantityInput = this.querySelector('quantity-input input.quantity__input');
    this.PDPQuantityInput = document.querySelector('product-info quantity-input input.quantity__input');
    this.stickyAtcPriceArr = document.querySelectorAll('.sticky-atc__price');
    this.stickySavingPriceArr = document.querySelectorAll('.sticky-atc__saving');
    this.productPriceEl = document.querySelector('product-info .price[data-product-price]');
    this.productSavingEl = document.querySelector('product-info .price[data-product-price]');
    this.currencySymbol = this.dataset.shopCurrencySymbol;
  }

  connectedCallback() {

    this.stickyATCUpper = document.querySelector('.section-main-product .price-wrapper')

    if (!this.stickyATCUpper) return;

    this.button = this.querySelector('[data-sticky-atc-btn]')
    this.colorSelector = this.querySelector('.product__color-selector')
    this.variantSelector = this.querySelector('.product__variant-selector')
    this.upsells = this.querySelector('.sticky-atc__upsells')
    this.upsellsDrawer = this.querySelector('.upsells-drawer')

    this.disableBuy = this.button.dataset.disableBuy;

    document.documentElement.style.setProperty('--footer-offset', `${this.offsetHeight}px`);

    document.addEventListener('scroll', this.debounce(this.handleUpperIntersect.bind(this), 100));

    this.colorSelectorDrawerListener()
    this.variantSelectorListener()

    this.button.addEventListener('click', this.onClickHandler.bind(this));

    this.mobileButton = this.querySelector('.mobile-trigger button');
    this.mobileButton?.addEventListener('click', this.onClickHandlerMobile.bind(this));
    this.upsells?.addEventListener('click', this.showUpsells.bind(this));

    if (this.quantityInput && this.PDPQuantityInput) {
      this.quantityInput.addEventListener('change', this.quantityInputListener.bind(this));
      this.PDPQuantityInput.addEventListener('change', this.PDPQuantityInputListener.bind(this));
    }
    if(this.quantityInput && !this.PDPQuantityInput){
      this.quantityInputWrapper.style.display = 'none';
    }
  }

  updateStickyAtcPrice() {
    this.stickyAtcPriceArr.forEach(priceEl => {
      // get upsell price
      const productPrice = this.extractMoneyValue(this.productPriceEl.dataset.productPrice);
      // mulsitply price by quantity
      const newPrice = productPrice * this.quantityInput.value;
      // update price
      priceEl.innerHTML = `${this.currencySymbol}${newPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
    });

    this.stickySavingPriceArr.forEach(savingEl => {
      const productSaving = this.extractMoneyValue(this.productPriceEl.dataset.productSaving);
      const newSaving = productSaving * this.quantityInput.value;
      if ( newSaving > 0 ) {
        savingEl.innerHTML = `${window.productStrings.saving} ${this.currencySymbol}${newSaving.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
      }
    });    
  }

   // Extracts money value from string ex: $10.00 -> 10.00
  extractMoneyValue(inputString) {
    return Number(inputString.replace(this.currencySymbol, "").replace(/,/g, '').trim());
  }

  showUpsells() {
    if(!this.upsellsDrawer || !this.upsells) return

    if(this.upsells.hasAttribute('aria-hidden') && this.upsells.getAttribute('aria-hidden') === 'true') {
      this.upsells.setAttribute('aria-hidden', 'false')
    } else {
      this.upsells.setAttribute('aria-hidden', 'true')
    }

    if(this.upsellsDrawer.hasAttribute('aria-expanded') && this.upsellsDrawer.getAttribute('aria-expanded') === 'true'){
      this.upsellsDrawer.setAttribute('aria-expanded', 'false')
    } else {
      this.upsellsDrawer.setAttribute('aria-expanded', 'true')
    }
  }

  handleUpperIntersect() {
    const elementPosition = this.stickyATCUpper.getBoundingClientRect().top;
    if (elementPosition < 0) {
      document.querySelector('sticky-atc').style.transform = "translateY(0)";
    } else {
      document.querySelector('sticky-atc').style.transform = "translateY(calc(100% + var(--layout-space-24)))";
    }
  }

  debounce(func, wait, immediate) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      const later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args)
    }
  }

  quantityInputListener() {
    // Update PDP input based on sticky ATC input
    this.PDPQuantityInput.value = this.quantityInput.value;
    // Update sticky ATC price
    this.updateStickyAtcPrice();
  }

  PDPQuantityInputListener() {
    // Update sticky ATC input based on PDP input
    this.quantityInput.value = this.PDPQuantityInput.value;
    // Update sticky ATC price
    this.updateStickyAtcPrice();
  }

  colorSelectorDrawerListener() {
    this.colorSelector?.querySelector('.product__color-selector--wrapper').addEventListener('click', () => {
      this.colorSelector.classList.toggle('active')
      this.variantSelector?.classList.remove('active')
    })
  }

  variantSelectorListener() {
    this.variantSelector?.querySelector('.product__variant-selector--wrapper').addEventListener('click', () => {
      this.variantSelector.classList.toggle('active')
      this.colorSelector?.classList.remove('active')
    })
  }


  onClickHandler(event) {
    event.preventDefault();

    if (this.disableBuy === 'true') {
      const disableModal = document.querySelector('details-modal.disable_buying_modal > details');
      const disableModalOverlay = document.querySelector('details-modal.disable_buying_modal .modal-overlay');
      if(disableModal){
        disableModal.setAttribute('open', true);
        disableModalOverlay.addEventListener('click', () => {
          disableModal.removeAttribute('open');
        });
      }
    } else {
      var mainAtc = document.querySelector('product-form .product-form__submit');
      if(mainAtc){
        mainAtc.click();
      }
    }
  }

  onClickHandlerMobile(event) {
    event.preventDefault();
    // Scroll to top on mobile devices
    if (window.innerWidth < 750) {
      window.scroll({ top: 0, behavior: 'smooth' });
    }
  }

}

customElements.define('sticky-atc', StickyATC);

}
